// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Qm06","label":"styles_label__31XzI"};